import React, { useContext } from 'react';
import classNames from 'classnames';
import { SummaryDropdownContext } from './index';
import Button from '../../../_common/button';
import OptionsWrapper from './options-wrapper';

export default function ButtonOptions({
  handleFinishChange,
  handleDeliveryChange,
}) {
  const {
    finishSelectorOptions,
    deliverySelectorOptions,
    selectedFinishOption,
    selectedDeliveryOption,
  } = useContext(
    SummaryDropdownContext
  );

  function joinOptionLabel(label) {
    return label.replace(/\s/, '_').toLowerCase();
  }

  return (
    <div className='print-order__order-buttons'>
      <OptionsWrapper className='print-finish-selector d-flex'
        disabledOptions={finishSelectorOptions.filter((o) => o.disabled)}
        blockingOption={selectedDeliveryOption}
        finishWrapper
      >
        {finishSelectorOptions.map(finish => (
          <ButtonOption
            disabled={finish.disabled}
            key={finish.label}
            isSelected={finish.selected}
            text={finish.label}
            thumbnailClass={joinOptionLabel(finish.label)}
            handleChange={handleFinishChange}
            value={finish.value}
            ariaLabel={`Select ${finish.label} Finish`}
          />
        ))}
      </OptionsWrapper>
      <OptionsWrapper
        className='delivery-method-selector d-flex'
        disabledOptions={deliverySelectorOptions.filter((o) => o.disabled)}
        blockingOption={selectedFinishOption}
      >
        {deliverySelectorOptions.map(deliveryOption => (
          <ButtonOption
            disabled={deliveryOption.disabled}
            key={deliveryOption.label}
            isSelected={deliveryOption.selected}
            text={deliveryOption.label}
            thumbnailClass={joinOptionLabel(deliveryOption.code)}
            handleChange={handleDeliveryChange}
            value={deliveryOption.value}
            ariaLabel={`${deliveryOption.value} Delivery Option`}
          />
        ))}
      </OptionsWrapper>
    </div>
  );
}

function ButtonOption({
  disabled,
  text,
  value,
  isSelected,
  handleChange,
  thumbnailClass,
  ariaLabel,
}) {
  return (
    <div className='col-6 px-1'>
      <Button
        className={classNames('w-100 h-100 btn-sm btn-outline-info', {
          selected: isSelected,
        })}
        disabled={disabled}
        type='button'
        onClick={() => handleChange(value)}
        aria-label={ariaLabel}>
        <span
          className={`summary-dropdown__option_thumbnail rounded-circle ${thumbnailClass}`}></span>
        <span className='summary-dropdown__option_title'>{text}</span>
      </Button>
    </div>
  );
}
